// extracted by mini-css-extract-plugin
export default {"wrapper":"NotAllowed_wrapper__HepyF","blurBkgd":"NotAllowed_blurBkgd__AZt5Z","opacityBkgd":"NotAllowed_opacityBkgd__+LAeN","content":"NotAllowed_content__tlN8F"};